<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link class="Header_menu__logo Header_menu__logo--sm" to="">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h">
        <div v-if="isMobile" class="inner">
          <h1 class="Form__head">
            MELON ONLINEご登録フォーム
          </h1>
        </div>
        <div class="inner">
          <div>
            <p class="Form__tx Form__tx--md _mg-t45">
              こちらよりご登録をお願いいたします。
            </p>
            <div :class="`Form__input_box Form__input_box--xlg ${($v.form.email.$error || errors.email) ? '_error' : ''}`">
              <div class="Form__input_heda Form__input--mt_md Form__input--mt_sm">
                メールアドレス
              </div>
              <input
                v-model.trim.lazy="$v.form.email.$model"
                class="Form__input"
                placeholder="sample@gmail.com"
                type="email"
                @click="checkMail = false"
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.form.email.required" class="Form__error_tx mgt-10">正しいメールアドレスを入力してください。</label>
                  <label v-if="!$v.form.email.email" class="Form__error_tx mgt-10">正しいメールアドレスを入力してください。</label>
                  <label v-if="!$v.form.email.maxLength" class="Form__error_tx mgt-10">メールの最大長254</label>
                  <label v-if="errors.email && checkMail" class="Form__error_tx mgt-10">{{ errors.email }}</label>
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--xlg ${$v.form.confirm_email.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input--mt_md Form__input--mt_sm">
                メールアドレス確認欄
              </div>
              <input
                v-model.trim.lazy="$v.form.confirm_email.$model"
                class="Form__input"
                placeholder="sample@gmail.com"
                type="email"
              >
              <div class="Form__error_box">
                <div v-if="!$v.form.confirm_email.required" class="Form__error_tx">
                  メールアドレスの確認が必要です
                </div>
                <div v-else-if="!$v.form.confirm_email.email" class="Form__error_tx">
                  正しいメールアドレスを入力してください。
                </div>
                <div v-else-if="!$v.form.confirm_email.sameAsEmail" class="Form__error_tx">
                  メールアドレスと確認用メールアドレスが異なっています。
                </div>
              </div>
            </div>
            <button
              :disabled="isLoading || couponError || isAlreadySent"
              class="Btn__blue Form__btn--mt_md Form__btn--mt_sp_xsm"
              @click="submitStep"
            >
              次へ進む
            </button>
            <div class="_fx _fx-cnter _mg-t45">
              <router-link class="Btn__dotted _ft-spacing" to="/signin">
                アカウントを既にお持ちの方はこちら
              </router-link>
            </div>
          </div>
        </div>
        <div class="Form_notice">
          <p>携帯電話のメールアドレス （@docomo.ne.jp、@ezweb.ne.jp、@softbank.ne.jpなど） は受信出来ない場合がありますので、info@the-melon.comからのメールが届くように受信設定をしていただくか、GmailやYahooなどパソコンのアドレスでのご登録を推奨しております。</p>
          <h2 class="Form_h2">
            同意事項
          </h2>
          <div class="Form_lsitArea">
            <ul>
              <li>本プログラムは治療を目的とした医療行為ではございません。疾患をお持ちの方は必ず医療機関でご相談の上、ご登録ください。</li>
              <li>本プログラムは個人的な悩みを相談するカウンセリングではございません。</li>
              <li>オンラインプログラム中の怪我や事故等に関してMELONはいかなる責任も負いかねます。ご自身で安全を確保してご参加ください。</li>
              <li>会員規約は<a href="https://www.the-melon.com/online-terms/">こちら</a>です。</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { email, required, maxLength, sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapState } from 'vuex'
import authService from '@/services/authService'
import { redirect } from '@/helpers'

const validations = {
  form: {
    email: {
      required,
      email,
      maxLength: maxLength(254),
      checkMail: false
    },
    confirm_email: {
      required,
      email,
      sameAsEmail: sameAs('email')
    }
  }
}
export default {
  name: 'RegisterEmail',
  mixins: [validationMixin],
  data() {
    return {
      errors: {
        email: ''
      },
      isLoading: false,
      isMobile: false,
      width: 0,
      height: 0,
      couponError: false,
      isAlreadySent: false,
      isError: true
    }
  },
  computed: {
    ...mapState({
      form: state => state.auth.signUpData
    })
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.getEmail()
  },
  methods: {
    async getEmail() {
      this.form.is_corp = true
      if (localStorage.getItem('email')) {
        const data = localStorage.getItem('email')
        this.form.email = JSON.parse(data).email
      }
      this.getReferrer()
      if (Object.keys(this.$router.currentRoute.query).length !== 0) {
        if (this.$router.currentRoute.query.company_id) {
          this.form.company_id = this.$router.currentRoute.query.company_id
        } else {
          this.form.company_id = null
        }

        if (this.$router.currentRoute.query.user_introduce) {
          this.form.user_introduce = this.$router.currentRoute.query.user_introduce
        } else {
          this.form.user_introduce = 0
        }

        if (this.$router.currentRoute.query.utm_source) {
          this.form.utm_source = this.$router.currentRoute.query.utm_source
        }

        if (this.$router.currentRoute.query.utm_medium) {
          this.form.utm_medium = this.$router.currentRoute.query.utm_medium
        }

        if (this.$router.currentRoute.query.utm_campaign) {
          this.form.utm_campaign = this.$router.currentRoute.query.utm_campaign
        }

        if (this.$router.currentRoute.query.utm_coupon) {
          this.form.utm_coupon = this.$router.currentRoute.query.utm_coupon
          await authService.verifyCoupon(this.form.utm_coupon).then((response) => {
            if (response.data.retrieve.valid === false || response.success === false) {
              alert('クーポンの期限が切れました')
              this.couponError = true
            }
          }).catch(() => {
            alert('クーポンの期限が切れました')
            const redirectPath = '/signin'
            redirect(redirectPath)
            this.couponError = true
          })
        }
      }
    },
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    reUpdateSubmitBtn() {
      this.isAlreadySent = false
      this.isError = true
    },
    submitStep() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        return
      }
      this.isLoading = true
      this.errors.email = ''
      this.isAlreadySent = true
      this.isError = true
      this.$store.dispatch('loading/updateLoading', true)
      authService.verifyEmail(this.form).then((res) => {
        this.isLoading = false
        this.isError = false
        this.$store.dispatch('loading/updateLoading', false)
        localStorage.setItem('email', JSON.stringify(this.form))
        redirect(res.url)
      }).catch((error) => {
        this.isAlreadySent = false
        this.errors.email = error.data.message
        this.isLoading = false
        this.$store.dispatch('loading/updateLoading', false)
        this.checkMail = true
      })
      setTimeout(this.reUpdateSubmitBtn, 60000)
    },
    getReferrer() {
      const referrer = document.referrer
      if (referrer.includes('google')) {
        this.form.utm_source = 'google'
        this.form.utm_medium = 'search'
        return
      }
      if (referrer.includes('yahoo')) {
        this.form.utm_source = 'yahoo'
        this.form.utm_medium = 'search'
        return
      }
      if (referrer.includes('facebook.com') || referrer.includes('fb.me')) {
        this.form.utm_source = 'facebook'
        this.form.utm_medium = 'SNS'
        return
      }
      if (referrer.includes('twitter.com') || referrer.includes('t.co')) {
        this.form.utm_source = 'twitter'
        this.form.utm_medium = 'SNS'
        return
      }
      if (referrer.includes('instagram.com')) {
        this.form.utm_source = 'instagram'
        this.form.utm_medium = 'SNS'
        return
      }
    }
  },
  validations: validations
}
</script>
